export const REQUEST_VALIDATION_LIMITS = {
    publicIdLength: 12,
    username: {minLength: 3, maxLength: 30},
    email: {maxLength: 50},
    password: {minLength: 8, maxLength: 128},
    profileDescription: {maxLength: 1000},
    // Mirrors RequestValidationConstants.PROFILE_STATEMENT_MAX_LENGTH and the database's
    // chk_application_users_profile_statement_length. One line at the top of a public profile, not a
    // second bio — and the browser is the only one of the three bounds that can say so in the member's
    // own language, which is why it refuses first.
    profileStatement: {maxLength: 280},
    groupOrSeriesName: {minLength: 3, maxLength: 255},
    description: {maxLength: 1000},
    longText: {maxLength: 2000},
    resolutionNote: {maxLength: 4000},
    url: {maxLength: 2000},
    // Mirrors RequestValidationConstants.GROUP_WELCOME_MESSAGE_MAX_LENGTH — a greeting, not a manifesto.
    groupWelcomeMessage: {maxLength: 500},
} as const;

export const USERNAME_PATTERN = /^[a-zA-Z0-9_-]+$/;
export const PUBLIC_ID_PATTERN = /^[a-zA-Z0-9]{12}$/;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
